import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "clabe",
})
export class ClabePipe implements PipeTransform {
  transform(value: string): string {
    let newVal = value.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})(\d{2}).*/, "$1 $2 $3 $4 $5");
    if (newVal.length === 0) {
      newVal = "";
    }
    return newVal;
  }

  parse(value: string): string {
    return value.replace(/\D/g, "");
  }
}
